import { Button, Flex } from 'antd';
import _ from 'lodash';
import { ExternalLink, Phone } from 'lucide-react';

const PreviewButtons = ({ buttons = [], className }) => {
    const sortedButtons = _.sortBy(buttons, ['index']);

    const renderButton = (button, index) => {
        let props = {
            block: true,
            children: button?.text ?? button?.sub_type,
            size: 'large'
        };

        switch (button.sub_type) {
            case 'url':
                props = {
                    ...props,
                    href: button?.url,
                    target: '_blank',
                    icon: <ExternalLink size={16} />,
                };
                break;
            case 'phone_number':
                props = {
                    ...props,
                    href: `tel:${button?.phone_number}`,
                    icon: <Phone size={16} />,
                };
                break;
            case 'quick_reply':
                break;
            default:
                break;
        }

        return <Button key={index} {...props} />;
    };

    if (sortedButtons.length === 1) {
        return (
            <Flex gap="small" vertical wrap>
                {renderButton(sortedButtons[0], 0)}
            </Flex>
        );
    }

    if (sortedButtons.length === 2) {
        return (
            <Flex gap="small" wrap>
                {sortedButtons.map((button, index) => (
                    <div key={index} style={{ flex: 1 }}>
                        {renderButton(button, index)}
                    </div>
                ))}
            </Flex>
        );
    }

    if (sortedButtons.length === 3) {
        return (
            <Flex gap="small" vertical wrap>
                <Flex gap="small">
                    {sortedButtons.slice(0, 2).map((button, index) => (
                        <div key={index} style={{ flex: 1 }}>
                            {renderButton(button, index)}
                        </div>
                    ))}
                </Flex>
                {renderButton(sortedButtons[2], 2)}
            </Flex>
        );
    }

    return null;
};

export default PreviewButtons;
